import React from 'react'

const Ssn = () => {
   return (
      <>
         <div className="row mb-title">
            <div className="col s12 m12 l12 x12">
               <h5><b>SUPERINTENDENCIA DE SEGUROS DE LA NACIÓN</b></h5>
            </div>
         </div>
         <div className="row">
            <div className="col s6 m6 l6 x6">
               <h6>Resolución 76-E/2018</h6>
            </div>
            <div className="col s6 m6 l6 x6 pull-x7">
               <a href="http://www2.ssn.gob.ar/files/Archivos/A_Superintendencia/capacitacion_ssn/G_aut_reg_/Resol_2018_76.pdf" target="_blank" className="btn waves-effect waves-light bg-latitud pulse" type="submit" name="action">Ver
                  <i className="material-icons right">send</i>
               </a>
            </div>
         </div>
         <div className="divider light-blue darken-4 mb-divider"></div>
         <div className="row">
            <div className="col s6 m6 l6 x6">
               <h6>Resolución 38052/2013</h6>
            </div>
            <div className="col s6 m6 l6 x6 pull-x7">
               <a href="http://servicios.infoleg.gob.ar/infolegInternet/anexos/220000-224999/224369/norma.htm" target="_blank" className="btn waves-effect waves-light bg-latitud pulse" type="submit" name="action">Ver
                  <i className="material-icons right">send</i>
               </a>
            </div>
         </div>
         <div className="divider light-blue darken-4 mb-divider"></div>
         <div className="row">
            <div className="col s6 m6 l6 x6">
               <h6>Resolución 38477/2014</h6>
            </div>
            <div className="col s6 m6 l6 x6 pull-x7">
               <a href="http://servicios.infoleg.gob.ar/infolegInternet/anexos/230000-234999/232554/norma.htm" target="_blank" className="btn waves-effect waves-light bg-latitud pulse" type="submit" name="action">Ver
                  <i className="material-icons right">send</i>
               </a>
            </div>
         </div>
         <div className="divider light-blue darken-4 mb-divider"></div>
         <div className="row">
            <div className="col s6 m6 l6 x6">
               <h6>Resolución 35550/11</h6>
            </div>
            <div className="col s6 m6 l6 x6 pull-x7">
               <a href="http://servicios.infoleg.gob.ar/infolegInternet/anexos/175000-179999/178890/norma.htm" target="_blank" className="btn waves-effect waves-light bg-latitud pulse" type="submit" name="action">Ver
                  <i className="material-icons right">send</i>
               </a>
            </div>
         </div>
      </>
   )
}

export default Ssn